/**
 * [EXCLUDE_LABELS] — This entire file can be removed once staging/prod DBs are split.
 *
 * Reads VITE_EXCLUDED_LABELS env var (comma-separated label_tags)
 * and provides helpers to exclude those labels from Supabase queries.
 *
 * Set it in the prod Vercel env only, to the test labels' ids (`labels.id`, which
 * `tracks.label_tag` references), at least:
 *   VITE_EXCLUDED_LABELS=ADMIN_LABEL,TESTING,TEST,NEGOTIATIONTESTING
 * The admin test label is ADMIN_LABEL; no published track carries ADMIN. A test
 * label left out stays in buyers' catalog and, by name, in the /tracks Label
 * filter (catalog-facets.ts). Whether to hide the remaining test labels too is
 * open: FRONTEND_TODO.md, "Tracks: Label filter".
 */

const EXCLUDED_LABELS: string[] = (() => {
  const raw = import.meta.env.VITE_EXCLUDED_LABELS;
  if (!raw || typeof raw !== "string") return [];
  return raw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
})();

export function getExcludedLabels(): string[] {
  return EXCLUDED_LABELS;
}

/**
 * Appends `.not("label_tag", "in", ...)` to a Supabase query builder
 * when excluded labels are configured. Returns the query unchanged
 * if no exclusions are set.
 */
export function excludeLabels<Q>(query: Q): Q {
  if (EXCLUDED_LABELS.length === 0) return query;
  return (query as any).not(
    "label_tag",
    "in",
    `(${EXCLUDED_LABELS.join(",")})`
  );
}
